import classNames from "classnames";
import { FC } from "react";

interface Props {
  title: string;
  hugElement?: boolean;
}
const CardTitle: FC<Props> = ({ title, hugElement }) => {
  return (
    <div
      className={classNames(
        hugElement ? "" : "sm:min-h-12 min-h-10 ",
        "md:mb-1.5  mb-1"
      )}
    >
      <p className="leading-5 md:leading-6 title-xsm md:title-md-demibold line-clamp-2 text-ellipsis">
        {title}
      </p>
    </div>
  );
};

export default CardTitle;
